import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import Checkbox from 'components/common/checkbox'
import EditForm from '../edit_form'
import styles from './edit_tracking.less'

const i18n = getI18n('components/edit_glimpse/edit_tracking')

class EditTracking extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
  }

  render() {
    const {
      fields: {
        shareProgress,
        shareContributorsDetails,
        shareContributionsAmount,
      },
    } = this.props
    return (
      <EditForm {...this.props}>
        <div styleName="title" role="heading" aria-level="1">
          {i18n('title')}
        </div>
        <div styleName="checkbox-wrapper">
          <Checkbox
            name="share"
            label={i18n('share_your_progress')}
            onChange={shareProgress.onChange}
            value={!!shareProgress.value}
            data-pa-click="shareProgressCheckbox"
          />
        </div>
        <div styleName="checkbox-wrapper">
          <Checkbox
            name="name-photo-checkbox"
            label={i18n('share_name_photo')}
            onChange={shareContributorsDetails.onChange}
            value={!!shareContributorsDetails.value}
            data-pa-click="shareNameCheckbox"
          />
        </div>
        <div styleName="checkbox-wrapper">
          <Checkbox
            name="amount-checkbox"
            label={i18n('share_amount')}
            onChange={shareContributionsAmount.onChange}
            value={!!shareContributionsAmount.value}
            disabled={!shareProgress.checked}
            data-pa-click="shareAmountCheckbox"
          />
        </div>

        <button
          data-pa-click="save"
          data-nemo="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditTracking, styles)
